import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from "react-router-dom"; 
import Menu from "../../comum/Menu/index.jsx";
import Footer from "../../comum/Footer/index.jsx";
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';
import Foto from "../Components/Foto";
import { Bar, Line } from 'react-chartjs-2';
import {
    Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend);

const AdminEquipamentos = () => {
    const [tab, setTab] = useState('catalogo');
    const [equipamentos, setEquipamentos] = useState([]);
    const [lojas, setLojas] = useState([]);
    const [editando, setEditando] = useState(null);
    const [lojasSelecionadas, setLojasSelecionadas] = useState([]);
    const [fotoBase64, setFotoBase64] = useState("");

    const [dataFiltro, setDataFiltro] = useState(new Date().toISOString().split('T')[0]);
    const [dashData, setDashData] = useState({ grafico: null, tabela: [] });
    const [evolucaoData, setEvolucaoData] = useState(null);

    const [analiseIndividual, setAnaliseIndividual] = useState(null);
    const [itemSelecionado, setItemSelecionado] = useState(null);
    const [fotoSelecionada, setFotoSelecionada] = useState(null);
    const navigate = useNavigate();

    const isRegional = localStorage.getItem("permiteRegional") === 'S' || localStorage.getItem("diretor") === 'S';

    // --- Verificação de Permissão ---
    useEffect(() => {
        const permiteRegional = localStorage.getItem("permiteRegional");
        if (permiteRegional !== "S") {
            alert("SEM PERMISSÃO AO ACESSO AO MÓDULO");
            navigate("/arbor/home");
        }
    }, [navigate]);

    // Paleta de cores para as lojas
    const colors = ['#0d6efd', '#6610f2', '#6f42c1', '#d63384', '#dc3545', '#fd7e14', '#ffc107', '#198754', '#20c997', '#0dcaf0'];

    const carregarCatalogo = useCallback(async () => {
        try {
            const res = await api.get('/equipamentos/master/lista');
            const dadosTratados = res.data.map(item => ({
                id_equip: item.ID_EQUIP ?? item.id_equip,
                descricao: (item.DESCRICAO ?? item.descricao ?? "").trim(),
                ativo: item.ATIVO ?? item.ativo,
                lojas_vinculadas: item.LOJAS_VINCULADAS ?? item.lojas_vinculadas,
                foto: item.FOTO ?? item.foto ?? ""
            }));
            setEquipamentos(dadosTratados);
        } catch (err) { console.error("Erro catálogo:", err); }
    }, []);

    const carregarLojas = useCallback(async () => {
        try {
            const res = await api.get("/equipamentos/admin/lojas-ativas");
            const dadosTratados = res.data.map(item => ({
                id_loja:
                    String(item.ID_LOJA ?? item.id_loja).padStart(2, '0'),
                razao: item.RAZAO ?? item.razao
            }));
            setLojas(dadosTratados);
        } catch (err) { console.error("Erro lojas:", err); }
    }, []);

    // FUNÇÃO AJUSTADA: Agora agrupa por loja
    const abrirGraficoEquipamento = async (item) => {
        try {
            setItemSelecionado(item);
            const res = await api.get(`/equipamentos/admin/evolucao-temporal?id_equip=${item.id_equip}`);
            const dados = res.data;
            console.log("Equipamento: " + item.id_equip)

            // 1. Datas únicas para o eixo X
            const labels = [...new Set(dados.map(d => d.data))].sort();

            // 2. IDs de lojas únicas presentes nesses dados
            const lojasIds = [...new Set(dados.map(d => d.id_loja))];

            // 3. Criar um dataset para cada loja encontrada
            const datasets = lojasIds.map((id, index) => ({
                label: `Loja ${String(id).padStart(2, '0')}`,
                data: labels.map(label => {
                    const registro = dados.find(d => d.data === label && d.id_loja === id);
                    return registro ? registro.total : 0;
                }),
                borderColor: colors[index % colors.length],
                backgroundColor: colors[index % colors.length],
                tension: 0.3,
                fill: false
            }));

            setAnaliseIndividual({ labels, datasets });
        } catch (err) {
            Swal.fire('Erro', 'Não foi possível carregar o gráfico deste item.', 'error');
        }
    };

    const carregarEvolucaoGeral = useCallback(async () => {
        try {
            const res = await api.get('/equipamentos/admin/evolucao-temporal');
            const dados = res.data;
            const labels = [...new Set(dados.map(d => d.data))].sort();
            const lojasIds = [...new Set(dados.map(d => d.id_loja))];

            const datasets = lojasIds.map((id, index) => ({
                label: `Loja ${String(id).padStart(2, '0')}`,
                data: labels.map(label => {
                    const registro = dados.find(d => d.data === label && d.id_loja === id);
                    return registro ? registro.total : 0;
                }),
                borderColor: colors[index % colors.length],
                backgroundColor: colors[index % colors.length],
                tension: 0.3
            }));

            setEvolucaoData({ labels, datasets });
        } catch (err) { console.error("Erro evolução:", err); }
    }, []);

    const carregarDashboard = useCallback(async () => {
        try {
            const res = await api.get(`/equipamentos/admin/status-geral?data=${dataFiltro}`);
            const dadosGrafico = res.data.grafico || [];

            const chartConfig = {
                // Formata o ID para '01', '02', etc.
                labels: dadosGrafico.map(g => {
                    const id = g.ID_LOJA ?? g.LOJA ?? g.id_loja ?? '?';
                    const idFormatado = String(id).padStart(2, '0');
                    return `Loja ${idFormatado}`;
                }),
                datasets: [{
                    label: '% Contado',
                    data: dadosGrafico.map(g => g.TOTAL ?? g.feito ?? 0),

                    // Cores condicionais (Vermelho < 100, Verde >= 100)
                    backgroundColor: dadosGrafico.map(g => {
                        const valor = g.TOTAL ?? g.feito ?? 0;
                        return valor < 100 ? 'rgba(220, 53, 69, 0.8)' : 'rgba(25, 135, 84, 0.8)';
                    }),

                    borderColor: dadosGrafico.map(g => {
                        const valor = g.TOTAL ?? g.feito ?? 0;
                        return valor < 100 ? '#dc3545' : '#198754';
                    }),

                    borderWidth: 1,
                    borderRadius: 5
                }]
            };
            setDashData({ grafico: chartConfig, tabela: res.data.tabela || [] });
        } catch (err) {
            setDashData({ grafico: null, tabela: [] });
        }
    }, [dataFiltro]);

    useEffect(() => {
        if (!isRegional) return;
        if (lojas.length === 0) carregarLojas();

        if (tab === 'catalogo') {
            carregarCatalogo();
        } else if (tab === 'dash') {
            carregarDashboard();
            carregarEvolucaoGeral();
        }
    }, [tab, isRegional, carregarCatalogo, carregarDashboard, carregarEvolucaoGeral, dataFiltro, lojas.length, carregarLojas]);

    const renderTabelaDinamica = () => {
        if (!dashData.tabela || dashData.tabela.length === 0)
            return <p className="text-center p-4 text-muted">Nenhuma movimentação para esta data.</p>;

        const colunasLojas = Object.keys(dashData.tabela[0])
            .filter(key => !['DESCRICAO', 'descricao', 'ID_EQUIP', 'id_equip'].includes(key))
            .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));

        return (
            <>
                <div className="d-none d-md-block">
                    <table className="table table-sm table-hover align-middle mb-0">
                        <thead className="table-dark">
                            <tr className="text-center">
                                <th className="text-start px-3">Equipamento</th>
                                {colunasLojas.map(col => <th key={col}>{col}</th>)}
                                <th className="bg-primary">TOTAL</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dashData.tabela.map((row, i) => {
                                const totalLinha = colunasLojas.reduce((acc, col) => acc + (Number(row[col]) || 0), 0);
                                return (
                                    <tr key={i} className="text-center">
                                        <td
                                            className="text-start fw-bold px-3 text-primary"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => abrirGraficoEquipamento({ id_equip: row.ID_EQUIP ?? row.id_equip, descricao: row.DESCRICAO ?? row.descricao })}
                                        >
                                            {row.DESCRICAO ?? row.descricao} <i className="bi bi-graph-up small ms-1"></i>
                                        </td>
                                        {colunasLojas.map(col => (
                                            <td key={col} className={row[col] > 0 ? "table-primary fw-bold" : "text-muted"}>
                                                {row[col] ?? 0}
                                            </td>
                                        ))}
                                        <td className="fw-bold bg-light text-primary">{totalLinha}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

                <div className="d-md-none p-2">
                    <div className="accordion shadow-sm" id="accordionEquipamentos">
                        {dashData.tabela.map((row, i) => {
                            const totalLinha = colunasLojas.reduce((acc, col) => acc + (Number(row[col]) || 0), 0);
                            const desc = row.DESCRICAO ?? row.descricao;
                            const idEquip = row.ID_EQUIP ?? row.id_equip;
                            return (
                                <div className="accordion-item" key={i}>
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed p-3" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${i}`}>
                                            <div className="d-flex justify-content-between w-100 align-items-center pe-3">
                                                <span className="fw-bold text-truncate" style={{ maxWidth: '65%' }}>{desc}</span>
                                                <span className="badge bg-primary rounded-pill">Total: {totalLinha}</span>
                                            </div>
                                        </button>
                                    </h2>
                                    <div id={`collapse${i}`} className="accordion-collapse collapse" data-bs-parent="#accordionEquipamentos">
                                        <div className="accordion-body bg-light">
                                            <div className="d-grid mb-3">
                                                <button className="btn btn-sm btn-outline-primary" onClick={() => abrirGraficoEquipamento({ id_equip: idEquip, descricao: desc })}>
                                                    <i className="bi bi-graph-up me-2"></i>Ver Evolução Temporal
                                                </button>
                                            </div>
                                            <div className="row g-2">
                                                {colunasLojas.map(col => row[col] > 0 && (
                                                    <div key={col} className="col-4 text-center">
                                                        <div className="bg-white border rounded p-2 shadow-sm">
                                                            <div style={{ fontSize: '10px' }} className="text-muted text-uppercase">Loja {col}</div>
                                                            <div className="fw-bold text-primary">{row[col]}</div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </>
        );
    };

    const handleAbrirEdicao = (eq) => {
        setEditando(eq);
        setFotoBase64(eq.foto || "");
        const strLojas = String(eq.lojas_vinculadas || "");
        const vinculadas = strLojas ? strLojas.split(',').map(v => Number(v.trim())) : [];
        setLojasSelecionadas(vinculadas);
    };

    const handleCheckLoja = (idLoja) => {
        setLojasSelecionadas(prev =>
            prev.includes(idLoja) ? prev.filter(id => id !== idLoja) : [...prev, idLoja]
        );
    };

    const handleUploadFoto = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.replace(/^data:image\/[a-z]+;base64,/, "");
                setFotoBase64(base64String);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSaveMaster = async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const finalFoto = fotoBase64.includes(",") ? fotoBase64.split(",")[1] : fotoBase64;

        const dados = {
            id_equip: Number(editando?.id_equip || 0),
            descricao: formData.get('descricao'),
            lojas: lojasSelecionadas,
            foto: finalFoto || "sem_foto"
        };

        try {
            await api.post('/equipamentos/master/salvar', dados);
            Swal.fire('Sucesso', 'Configurações salvas!', 'success');
            setEditando(null);
            carregarCatalogo();
        } catch (err) {
            Swal.fire('Erro', 'Falha ao salvar equipamento.', 'error');
        }
    };

    const toggleAtivo = async (id, statusAtual) => {
        try {
            await api.post('/equipamentos/master/status', {
                id_equip: id,
                ativo: statusAtual === 'S' ? 'N' : 'S'
            });
            carregarCatalogo();
        } catch (err) { Swal.fire('Erro', 'Status não alterado', 'error'); }
    };

    if (!isRegional) return <div className="p-5 text-center"><h4>Acesso Negado.</h4></div>;

    return (
        <>
            <Menu modulo="ARBOR" />
            <div className="container mt-5 pt-4 mb-5">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="fw-bold text-uppercase m-0">Gestão de Equipamentos</h4>
                    <div className="btn-group shadow-sm">
                        <button className={`btn ${tab === 'catalogo' ? 'btn-primary' : 'btn-light'}`} onClick={() => setTab('catalogo')}>Catálogo</button>
                        <button className={`btn ${tab === 'dash' ? 'btn-primary' : 'btn-light'}`} onClick={() => setTab('dash')}>Dashboard</button>
                    </div>
                </div>

                {tab === 'catalogo' && (
                    <div className="row g-3">
                        <div className="col-12 text-end mb-2">
                            <button className="btn btn-dark btn-sm shadow" onClick={() => { setEditando({ id_equip: 0, descricao: "" }); setLojasSelecionadas([]); setFotoBase64(""); }}>
                                <i className="bi bi-plus-lg me-2"></i>Novo Equipamento
                            </button>
                        </div>
                        {equipamentos.map(eq => (
                            <div className="col-md-4 col-sm-6" key={eq.id_equip}>
                                <div className={`card shadow-sm h-100 border-0 ${eq.ativo !== 'S' ? 'opacity-50 bg-light' : ''}`}>
                                    <div
                                        className="text-center bg-white p-3 border-bottom"
                                        style={{ height: '160px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                                        onClick={() => setFotoSelecionada({
                                            foto: eq.foto && eq.foto !== "sem_foto" ? `data:image/png;base64,${eq.foto}` : null,
                                            nome: eq.descricao,
                                            loja: "Catálogo Geral"
                                        })}
                                    >
                                        {eq.foto && eq.foto !== "sem_foto" ? (
                                            <img src={`data:image/png;base64,${eq.foto}`} alt="equip" style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }} />
                                        ) : (
                                            <i className="bi bi-box-seam text-light-emphasis" style={{ fontSize: '3.5rem' }}></i>
                                        )}
                                    </div>
                                    <div className="card-body d-flex flex-column">
                                        <h6 className="fw-bold mb-1 text-uppercase">{eq.descricao}</h6>
                                        <p className="text-muted mb-3 flex-grow-1" style={{ fontSize: '11px' }}>
                                            <i className="bi bi-geo-alt me-1"></i>Lojas: {eq.lojas_vinculadas || 'Nenhuma'}
                                        </p>
                                        <div className="d-flex flex-wrap gap-2">
                                            <button className="btn btn-sm btn-outline-primary flex-grow-1" onClick={() => handleAbrirEdicao(eq)}>Editar</button>
                                            <button className={`btn btn-sm flex-grow-1 ${eq.ativo === 'S' ? 'btn-outline-danger' : 'btn-outline-success'}`} onClick={() => toggleAtivo(eq.id_equip, eq.ativo)}>
                                                {eq.ativo === 'S' ? 'Desativar' : 'Ativar'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {tab === 'dash' && (
                    <div className="row">
                        <div className="col-12 mb-4">
                            <div className="card p-3 shadow-sm border-0">
                                <h6 className="fw-bold text-uppercase mb-3" style={{ fontSize: '13px' }}><i className="bi bi-graph-up me-2"></i>Evolução Geral (Lojas)</h6>
                                <div style={{ height: '300px' }}>
                                    {evolucaoData ? (
                                        <Line data={evolucaoData} options={{ maintainAspectRatio: false, responsive: true }} />
                                    ) : <div className="text-center mt-5 text-muted small">Carregando evolução...</div>}
                                </div>
                            </div>
                        </div>

                        <div className="col-12 mb-3 d-flex justify-content-between align-items-center bg-light p-3 rounded shadow-sm">
                            <h6 className="m-0 fw-bold text-primary"><i className="bi bi-calendar3 me-2"></i>Status por Data</h6>
                            <input type="date" className="form-control form-control-sm w-auto fw-bold" value={dataFiltro} onChange={(e) => setDataFiltro(e.target.value)} />
                        </div>
                        <div className="col-12 mb-4">
                            <div className="card p-3 shadow-sm border-0" style={{ height: '380px' }}>
                                {dashData.grafico ? (
                                    <Bar data={dashData.grafico} options={{ maintainAspectRatio: false, responsive: true }} />
                                ) : <div className="text-center mt-5 text-muted">Aguardando dados...</div>}
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="table-responsive card shadow-sm border-0">
                                {renderTabelaDinamica()}
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Modal de Edição */}
            {editando && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)', zIndex: 1050 }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <form className="modal-content border-0 shadow-lg" onSubmit={handleSaveMaster}>
                            <div className="modal-header bg-dark text-white">
                                <h5 className="modal-title fw-bold">CONFIGURAR EQUIPAMENTO</h5>
                                <button type="button" className="btn-close btn-close-white" onClick={() => setEditando(null)}></button>
                            </div>
                            <div className="modal-body p-4">
                                <div className="row">
                                    <div className="col-md-6 border-end">
                                        <label className="small fw-bold text-uppercase mb-1">Nome / Descrição</label>
                                        <input name="descricao" className="form-control mb-3" defaultValue={editando.descricao} required />
                                        <label className="small fw-bold text-uppercase mb-1">Foto</label>
                                        <div className="text-center border rounded bg-light p-3 mb-2" style={{ minHeight: '150px' }}>
                                            {fotoBase64 ? <img src={`data:image/png;base64,${fotoBase64}`} style={{ maxWidth: '100%', maxHeight: '140px' }} alt="Preview" /> : <i className="bi bi-camera-fill text-muted display-4"></i>}
                                        </div>
                                        <input type="file" className="form-control form-control-sm" accept="image/*" onChange={handleUploadFoto} />
                                    </div>
                                    <div className="col-md-6 ps-md-4">
                                        <label className="small fw-bold text-uppercase mb-1">Lojas Autorizadas</label>
                                        <div className="border rounded p-3 bg-white" style={{ height: '235px', overflowY: 'auto' }}>
                                            {lojas.map(l => (
                                                <div key={l.id_loja} className="form-check mb-1">
                                                    <input className="form-check-input" type="checkbox" id={`loja${l.id_loja}`} checked={lojasSelecionadas.includes(l.id_loja)} onChange={() => handleCheckLoja(l.id_loja)} />
                                                    <label className="form-check-label small" htmlFor={`loja${l.id_loja}`}>{l.id_loja} - {l.razao}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-secondary" onClick={() => setEditando(null)}>Cancelar</button>
                                <button type="submit" className="btn btn-primary fw-bold">SALVAR</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Modal de Gráfico Individual */}
            {analiseIndividual && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1060 }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content shadow-lg border-0">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold text-primary">
                                    <i className="bi bi-graph-up me-2"></i>{itemSelecionado?.descricao}
                                </h5>
                                <button type="button" className="btn-close" onClick={() => setAnaliseIndividual(null)}></button>
                            </div>
                            <div className="modal-body" style={{ height: '400px' }}>
                                <Line
                                    data={analiseIndividual}
                                    options={{
                                        maintainAspectRatio: false,
                                        responsive: true,
                                        plugins: { legend: { display: true, position: 'bottom' } }
                                    }}
                                />
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setAnaliseIndividual(null)}>Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Foto
                show={!!fotoSelecionada}
                onClose={() => setFotoSelecionada(null)}
                foto={fotoSelecionada?.foto}
                nome={fotoSelecionada?.nome}
                info01={fotoSelecionada?.loja}
                info02=""
            />
            <Footer />
        </>
    );
};

export default AdminEquipamentos;